import request from '../utils/request'
// import App from "@/api/app-ether"
// import {BEP20_ABI} from './BEP20_ABI'
import { showLoadingToast,closeToast,showToast } from 'vant';
const pay_USDT_Decimal = 18;
const token_Decimal = 6;
BigNumber.default.config({ DECIMAL_PLACES: 18 })
// import {checkConnect,getToast} from "./base"
//-----chainId===5测试
const payContract = "0xaC271f0B1020491194bF7cC4468F4CF96cCC024F";
const tokenContract = "0x72d688Cfe755f5369F2CA819Ab8Ae49D8d53d87A";
const MonoToken = '0x72d688Cfe755f5369F2CA819Ab8Ae49D8d53d87A';
import {toToast} from '@/utils'
import { Tlang } from '@/language';
//  初始化接口
export function ValidateCode(data) {
  return request({
    url: '/Qt/common/GetValidateCode',
    method: 'post',
    data,
  })
}

export function MemberName(data) {
  return request({
    url: '/Qt/DefaultF/GetMemberInfo',
    method: 'post',
    data,
  })
}

export function CarouselImage(params) {
  return request({
    url: '/Qt/DefaultF/GetCarouselImage',
    method: 'get',
    params,
  })
}

export function Login(data) {
  showLoadingToast({
      duration:0,
      message:Tlang.Logging_in,
      forbidClick: true,
    });
  return request({
    url: '/Qt/DefaultF/RegeditLogins',
    method: 'post',
    data,
  })
}


export function getActiveted(params) {
  return request({
    url: '/Qt/MemberF/Activeted',
    method: 'get',
    params,
  })
}

export function postActiveted(data) {
  showLoadingToast({
      duration:0,
      message:Tlang.Buying+'...',
      forbidClick: true,
    });
  return request({
    url: '/Qt/MemberF/Activeted',
    method: 'post',
    data,
  })
}


export function GetFinancialDesc(params) {
  return request({
    url: '/Qt/MemberF/GetFinancialDesc',
    method: 'get',
    params,
  })
}

export function GetTicketInfo(params) {
  return request({
    url: '/Qt/EntryF/GetTicketInfo',
    method: 'get',
    params,
  })
}

export function GetWorkPermit(params) {
  return request({
    url: '/Qt/FinanceF/GetWorkPermit',
    method: 'get',
    params,
  })
}

export function ReceiveIncome(data) {
  showLoadingToast({
      duration:0,
      message:Tlang.Receiving+ '...',
      forbidClick: true,
    });
  return request({
    url: '/Qt/CardF/ReceiveIncome',
    method: 'post',
    data,
  })
}

export function BuyWorkPermit(data) {
  showLoadingToast({
      duration:0,
      message:Tlang.Buying+'...',
      forbidClick: true,
    });
  return request({
    url: '/Qt/FinanceF/BuyWorkPermit',
    method: 'post',
    data,
  })
}


export function BuyTicket(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Buying+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/EntryF/BuyTicket',
    method: 'post',
    data,
  })
}


export function GetEntryInfo(params) {
  return request({
    url: '/Qt/EntryF/GetEntryInfo',
    method: 'get',
    params,
  })
}


export function GetMyEntryRecordList(params) {
  return request({
    url: '/Qt/EntryF/GetMyEntryRecordList',
    method: 'get',
    params,
  })
}


export function GetMyRebateRecordList(params) {
  return request({
    url: '/Qt/EntryF/GetMyRebateRecordList',
    method: 'get',
    params,
  })
}

export function EntrySubmit(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/EntryF/EntrySubmit',
    method: 'post',
    data,
  })
}


export function RegeditSumbit(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/DefaultF/RegeditSumbit',
    method: 'post',
    data,
  })
}

export function ForgetPasswordForTel(data) {
  return request({
    url: '/Qt/DefaultF/ForgetPasswordForTel',
    method: 'post',
    data,
  })
}

export function RegisterCode(data) {
  return request({
    url: '/Qt/DefaultF/RegisterCode',
    method: 'post',
    data,
  })
}

export function ForgetPasswordCode(data) {
  return request({
    url: '/Qt/DefaultF/ForgetPasswordCode',
    method: 'post',
    data,
  })
}

export function EditMemberLoginPwd(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/MemberF/EditMemberLoginPwd',
    method: 'post',
    data,
  })
}

export function NewNews(params) {
  return request({
    url: '/Qt/DefaultF/NewNews',
    method: 'get',
    params,
  })
}

export function GetNewsList(params) {
  return request({
    url: '/Qt/NoticeF/GetNewsList',
    method: 'get',
    params,
  })
}

export function GetChanceCard(params) {
  return request({
    url: '/Qt/CardF/GetChanceCard',
    method: 'get',
    params,
  })
}

export function GetChanceCardList(params) {
  return request({
    url: '/Qt/CardF/GetChanceCardList',
    method: 'get',
    params,
  })
}

export function SubmitExchange(params) {
  return request({
    url: '/Qt/FinanceF/SubmitExchange',
    method: 'get',
    params,
  })
}


export function GetExchanges(params) {
  return request({
    url: '/Qt/FinanceF/GetExchanges',
    method: 'get',
    params,
  })
}

export function toSubmitExchange(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/SubmitExchange',
    method: 'post',
    data,
  })
}


export function BuyChanceCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Extracting+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/BuyChanceCard',
    method: 'post',
    data,
  })
}

export function ActivateChanceCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Activating+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/ActivateChanceCard',
    method: 'post',
    data,
  })
}


export function GetActivateChanceCard(params) {
  return request({
    url: '/Qt/CardF/GetActivateChanceCard',
    method: 'get',
    params,
  })
}

export function GetPracticeCardList(params) {
  return request({
    url: '/Qt/CardF/GetPracticeCardList',
    method: 'get',
    params,
  })
}

export function GetActivatePracticeCard(params) {
  return request({
    url: '/Qt/CardF/GetActivatePracticeCard',
    method: 'get',
    params,
  })
}

export function ActivatePracticeCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/ActivatePracticeCard',
    method: 'post',
    data,
  })
}

export function TransferPracticeCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/TransferPracticeCard',
    method: 'post',
    data,
  })
}

export function GetBankInfo(params) {
  return request({
    url: '/Qt/FinanceF/GetBankInfo',
    method: 'get',
    params,
  })
}

export function GetBox(params) {
  return request({
    url: '/Qt/CardF/GetBox',
    method: 'get',
    params,
  })
}

export function GetBoxInfo(params) {
  return request({
    url: '/Qt/CardF/GetBoxInfo',
    method: 'get',
    params,
  })
}

export function GetWorkCardList(params) {
  return request({
    url: '/Qt/CardF/GetWorkCardList',
    method: 'get',
    params,
  })
}

export function GetActivateWorkCard(params) {
  return request({
    url: '/Qt/CardF/GetActivateWorkCard',
    method: 'get',
    params,
  })
}

export function BuyBox(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Opening+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/BuyBox',
    method: 'post',
    data,
  })
}

export function ActivateWorkCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Activating+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/ActivateWorkCard',
    method: 'post',
    data,
  })
}
export function TransferWorkCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/TransferWorkCard',
    method: 'post',
    data,
  })
}

export function TransferChanceCard(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/TransferChanceCard',
    method: 'post',
    data,
  })
}

export function ReleaseAward(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Receiving+ '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/CardF/ReleaseAward',
    method: 'post',
    data,
  })
}

export function GetTransferList(params) {
  return request({
    url: '/Qt/CardF/GetTransferList',
    method: 'get',
    params,
  })
}

export function GetChanceTransferList(params) {
  return request({
    url: '/Qt/CardF/GetChanceTransferList',
    method: 'get',
    params,
  })
}

export function BankOut(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/BankOut',
    method: 'post',
    data,
  })
}

export function BankIn(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/BankIn',
    method: 'post',
    data,
  })
}

export function GetNewsDetail(params) {
  return request({
    url: '/Qt/NoticeF/GetNewsDetail',
    method: 'get',
    params,
  })
}


export function GetGradeInfo(params) {
  return request({
    url: '/Qt/MemberF/GetGradeInfo',
    method: 'get',
    params,
  })
}

export function MyTeamList(params) {
  return request({
    url: '/Qt/MemberF/MyTeamList',
    method: 'get',
    params,
  })
}

export function UpdateRecommend(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/MemberF/UpdateRecommend',
    method: 'post',
    data,
  })
}

export function EditMemberView(data) {
  showLoadingToast({
    duration:0,
    message:Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/MemberF/EditMemberView',
    method: 'post',
    data,
  })
}

export function getMemberView(params) {
  return request({
    url: '/Qt/MemberF/EditMemberView',
    method: 'get',
    params,
  })
}

export function MemberView(params) {
  return request({
    url: '/Qt/MemberF/MemberView',
    method: 'get',
    params,
  })
}

export function uploadimg(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Uploading+'...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/common/uploadimg',
    method: 'post',
    data,
  })
}


export function ReferralLink(params) {
  return request({
    url: '/Qt/MemberF/GetReferralLink',
    method: 'get',
    params,
  })
}


export function AwardsRecord(params) {
  return request({
    url: '/Qt/FinanceF/GainAwardsRecord',
    method: 'get',
    params,
  })
}


export function Loginout(data) {
  // showLoadingToast({
  //   duration:0,
  //   message: '退出中...',
  //   forbidClick: true,
  // });
  return request({
    url: '/Qt/MemberF/Loginout',
    method: 'post',
    data,
  })
}


export function TransfersConfig(params) {
  return request({
    url: '/Qt/FinanceF/SubmitTransfers',
    method: 'get',
    params,
  })
}


export function GetBillflowList(params) {
  return request({
    url: '/Qt/FinanceF/GetBillflowList',
    method: 'get',
    params,
  })
}


export function GetSubmitWithdraw(params) {
  return request({
    url: '/Qt/FinanceF/SubmitWithdraw',
    method: 'get',
    params,
  })
}

export function GetWithdraws(params) {
  return request({
    url: '/Qt/FinanceF/GetWithdraws',
    method: 'get',
    params,
  })
}

export function getSubmitTransfers(params) {
  return request({
    url: '/Qt/FinanceF/SubmitTransfers',
    method: 'get',
    params,
  })
}

export function GetTransfersList(params) {
  return request({
    url: '/Qt/FinanceF/GetTransfersList',
    method: 'get',
    params,
  })
}


export function GetRechargeOnlineConfig(params) {
  return request({
    url: '/Qt/FinanceF/GetRechargeOnlineConfig',
    method: 'get',
    params,
  })
}

export function GetRemittances(params) {
  return request({
    url: '/Qt/FinanceF/GetRemittances',
    method: 'get',
    params,
  })
}

export function SubmitTransfers(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/SubmitTransfers',
    method: 'post',
    data,
  })
}

export function SubmitWithdraw(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Submitting + '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/SubmitWithdraw',
    method: 'post',
    data,
  })
}

export function RechargeOnlineSubmit(data) {
  showLoadingToast({
    duration:0,
    message:Tlang.Recharging+ '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/FinanceF/RechargeOnlineSubmit',
    method: 'post',
    data,
  })
}

export function ReceiveTeamAward(data) {
  showLoadingToast({
    duration:0,
    message:Tlang.Receiving+ '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/MemberF/ReceiveTeamAward',
    method: 'post',
    data,
  })
}

export function ReceiveNodeAward(data) {
  showLoadingToast({
    duration:0,
    message: Tlang.Receiving+ '...',
    forbidClick: true,
  });
  return request({
    url: '/Qt/MemberF/ReceiveNodeAward',
    method: 'post',
    data,
  })
}


 //转账
//  function UsdtTrans(toAddr1,amount1,callback){
//   ERC20Transfer(tokenContract, token_Decimal,toAddr1,amount1,res=>{
//     if(res) callback(res)
//     else  callback('')
//   });
// }
// //token转账
// export function tokenTrans(toAddr1,amount1,callback){
//   ERC20Transfer(tokenContract, token_Decimal,toAddr1,amount1,res=>{
//     if(res) callback(res)
//     else  callback('')
//   });
// }

// export function ERC20Transfer(tokenAddr, decimal,toAddr1,amount1,callback) {

//   if(!checkConnect()) return
//   var ownerAddr = App.MetaMask.getCurrentAccount();
//   var toAddr = toAddr1;
//   var amount = amount1;
//   var realAmount = BigNumber(amount).mult(BigNumber(10).pow(decimal));
//   App.MetaMask.getContractInstance(tokenAddr, BEP20_ABI, function(error, instance) {
//       if (error) {
//           console.log(error);
//           toToast(error.message)
//           callback(null)
//           return;
//       }
//       getToast()
//       instance.methods.transfer(toAddr, realAmount).send({ from: ownerAddr }).then(function(result) {
//           console.log(result.transactionHash)
//           callback(result.transactionHash)
//           console.log("transfer callback", result);
//       }).catch(function(error) {
//         toToast(error.message);
//         // callback(null)
//         // // console.log(error)
//         // var obj = App.MetaMask.getError(error);
//         // toToast(obj.message);

//     });
//   })
// }